import { PropsWithChildren } from 'react';

export const FixedBottomBarContainer = ({ children }: PropsWithChildren) => (
  <div className='fixed bottom-0 left-0 z-[100] flex h-17 w-full items-center rounded-t-2xl bg-white px-6 py-5 shadow-cardShadow lg:px-0'>
    <div className='mx-auto w-full max-w-screen-lg items-center'>
      <div className='flex items-center justify-between'>{children}</div>
    </div>
  </div>
);
